import { AccountCreationConfigItem } from './account-creation-config-item';
export class AccountCreationConfigurations {

    SystemKey: AccountCreationConfigItem = new AccountCreationConfigItem();
    UserRole: AccountCreationConfigItem = new AccountCreationConfigItem();
    SelectSchool: AccountCreationConfigItem = new AccountCreationConfigItem();
    SchoolNotInList: AccountCreationConfigItem = new AccountCreationConfigItem();
    MiddleName: AccountCreationConfigItem = new AccountCreationConfigItem();
    DateOfBirth: AccountCreationConfigItem = new AccountCreationConfigItem();
    Cellphone: AccountCreationConfigItem = new AccountCreationConfigItem();
    MobileOptIn: AccountCreationConfigItem = new AccountCreationConfigItem();
    UseXapEmail: AccountCreationConfigItem = new AccountCreationConfigItem();
    DayPhone: AccountCreationConfigItem = new AccountCreationConfigItem();
    EveningPhone: AccountCreationConfigItem = new AccountCreationConfigItem();
    PermanentAddress: AccountCreationConfigItem = new AccountCreationConfigItem();
    GradYear: AccountCreationConfigItem = new AccountCreationConfigItem();
    EmailConfirmation: AccountCreationConfigItem = new AccountCreationConfigItem();
    FirstName: AccountCreationConfigItem = new AccountCreationConfigItem();
    LastName: AccountCreationConfigItem = new AccountCreationConfigItem();
    Email: AccountCreationConfigItem = new AccountCreationConfigItem();
    EmailValidate: AccountCreationConfigItem = new AccountCreationConfigItem();
    AccountName: AccountCreationConfigItem = new AccountCreationConfigItem();
    Password: AccountCreationConfigItem = new AccountCreationConfigItem();
    PasswordConfirmation: AccountCreationConfigItem = new AccountCreationConfigItem();
    SecurityQuestion: AccountCreationConfigItem = new AccountCreationConfigItem();
    SecurityAnswer: AccountCreationConfigItem = new AccountCreationConfigItem();

    // new additions
    AddressPanel: AccountCreationConfigItem = new AccountCreationConfigItem();
    Street: AccountCreationConfigItem = new AccountCreationConfigItem();
    City: AccountCreationConfigItem = new AccountCreationConfigItem();
    State: AccountCreationConfigItem = new AccountCreationConfigItem();
    Zipcode: AccountCreationConfigItem = new AccountCreationConfigItem();
    County: AccountCreationConfigItem = new AccountCreationConfigItem();
    Country: AccountCreationConfigItem = new AccountCreationConfigItem();
    InternationalPostalCode: AccountCreationConfigItem = new AccountCreationConfigItem();
    AdditionalInformationPanel: AccountCreationConfigItem = new AccountCreationConfigItem();
    AccountSecurityPanel: AccountCreationConfigItem = new AccountCreationConfigItem();
    ImportChoices: AccountCreationConfigItem = new AccountCreationConfigItem();
    PersonalInfoSharing: AccountCreationConfigItem = new AccountCreationConfigItem();
    Coppa: AccountCreationConfigItem = new AccountCreationConfigItem();
    Sex: AccountCreationConfigItem = new AccountCreationConfigItem();
    Ethnicity: AccountCreationConfigItem = new AccountCreationConfigItem();
    HowHear: AccountCreationConfigItem = new AccountCreationConfigItem();    

    MailingAddressPanel: AccountCreationConfigItem = new AccountCreationConfigItem();
    MailingStreet: AccountCreationConfigItem = new AccountCreationConfigItem();
    MailingCity: AccountCreationConfigItem = new AccountCreationConfigItem();
    MailingState: AccountCreationConfigItem = new AccountCreationConfigItem();
    MailingZipcode: AccountCreationConfigItem = new AccountCreationConfigItem();
    MailingCounty: AccountCreationConfigItem = new AccountCreationConfigItem();
    MailingCountry: AccountCreationConfigItem = new AccountCreationConfigItem();
    MailingInternationalPostalCode: AccountCreationConfigItem = new AccountCreationConfigItem();

    Religion: AccountCreationConfigItem = new AccountCreationConfigItem();
    Ssn: AccountCreationConfigItem = new AccountCreationConfigItem();
    StudentStateId: AccountCreationConfigItem = new AccountCreationConfigItem();
    Citizen: AccountCreationConfigItem = new AccountCreationConfigItem();

    CoppaRestricted: AccountCreationConfigItem = new AccountCreationConfigItem();
    BadEmailDomain: AccountCreationConfigItem = new AccountCreationConfigItem();
}